import type { ReactNode } from "react";
import { cn } from "@/lib/utils";
import { reviewLabel } from "../lib/format";

export function PageWidth({
  children,
  className,
}: {
  children: ReactNode;
  className?: string;
}) {
  return (
    <div className={cn("mx-auto w-full max-w-6xl px-4 py-6 sm:px-6", className)}>
      {children}
    </div>
  );
}

export function StarRow({ count }: { count: number }) {
  return (
    <span
      className="text-[13px] tracking-tight text-[#febb02]"
      aria-label={`${count} stars`}
    >
      {"★".repeat(Math.max(0, Math.min(5, count)))}
    </span>
  );
}

export function ScorePill({
  rating,
  reviews,
}: {
  rating: number;
  reviews: number;
}) {
  const { score, label } = reviewLabel(rating);
  return (
    <div className="flex items-center gap-2">
      <span className="inline-flex h-8 min-w-8 items-center justify-center rounded-md rounded-bl-none bg-[#003580] px-1.5 text-sm font-bold text-white">
        {score}
      </span>
      <span className="text-sm leading-tight">
        <span className="font-semibold text-[#1a1a1a]">{label}</span>
        <span className="block text-xs text-[#595959]">
          {reviews.toLocaleString("en-IN")} reviews
        </span>
      </span>
    </div>
  );
}
